<template>
  <nav>
    <ul class="pagination-list">
      <li class="pagination-list__item">
        <v-btn
          icon
          :disabled="prevBtnDisabled"
          @click="changePageHandler(currentPage - 1)"
        >
          <i
            class="pagination-list__item__icon icon-arrow-left-bold"
            :class="{ 'disabled': prevBtnDisabled }"
          />
        </v-btn>
      </li>
      <template v-for="page in totalPage">
        <li
          v-if="page === totalPage && Math.abs(page - currentPage) > 2 && !showAllPagination"
          :key="page + 'prev'"
          class="pagination-list__item pagination-list__item--border"
        >
          <v-btn
            class="pagination-list__item__btn"
            @click="changePageHandler(currentPage + 2)"
          >
            ...
          </v-btn>
        </li>
        <li
          v-if="Math.abs(page - currentPage) < 2 || page === totalPage || page === 1 || showAllPagination"
          :key="page"
          class="pagination-list__item pagination-list__item--border"
          :class="{ 'active': page === currentPage }"
        >
          <v-btn
            class="pagination-list__item__btn"
            @click="changePageHandler(page)"
          >
            {{ page }}
          </v-btn>
        </li>
        <li
          v-if="page === 1 && Math.abs(page - currentPage) > 2 && !showAllPagination"
          :key="page + 'next'"
          class="pagination-list__item pagination-list__item--border"
        >
          <v-btn
            class="pagination-list__item__btn"
            @click="changePageHandler(currentPage - 2)"
          >
            ...
          </v-btn>
        </li>
      </template>
      <li class="pagination-list__item">
        <v-btn
          icon
          :disabled="nextBtnDisabled"
          @click="changePageHandler(currentPage + 1)"
        >
          <i
            class="pagination-list__item__icon icon-arrow-right-bold"
            :class="{ 'disabled': nextBtnDisabled }"
          />
        </v-btn>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  props: {
    currentPage: {
      type: Number,
      default: 1
    },
    totalPage: {
      type: Number,
      default: 0
    }
  },
  computed: {
    prevBtnDisabled () {
      return this.currentPage === 1
    },
    nextBtnDisabled () {
      return this.currentPage >= this.totalPage
    },
    showAllPagination () {
      return this.totalPage <= 5
    }
  },
  methods: {
    changePageHandler (page) {
      this.$emit('changeActivePageHandler', page)
    }
  }
}
</script>

<style lang="scss" scoped>
.pagination-list {
  display: flex;
  justify-content: center;
  align-items: center;
  list-style: none;
  &__item {
    display: flex;
    align-items: center;
    +.pagination-list__item {
      margin-left: 12px;
    }
    &--border:not(.active) {
      border-radius: 2px;
      border: 1px solid $color-border-primary;
    }
    &__icon {
      font-size: pxTorem(24px);
      cursor: pointer;
      &::before {
        color: $color-primary;
      }
      &.disabled {
        cursor: not-allowed;
        pointer-events: all;
        &::before {
          color: $color-caption;
        }
      }
    }
  }

  ::v-deep {
    .pagination-list__item {
      .pagination-list__item__btn {
        min-width: 28px;
        width: 28px;
        height: 28px;
        padding: 0;
        box-shadow: none;
        span {
          font-size: pxTorem(17px);
          color: $color-text-primary;
        }
      }
      &.active {
        .pagination-list__item__btn {
          background-color: $color-primary;
          span {
            color: $color-text-inverse;
          }
        }
      }
      &:not(.active) {
        .pagination-list__item__btn {
          background-color: $color-background-secondary;
        }
      }
    }
  }
}
</style>
